import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Card,
  CardHeader,
  UncontrolledCollapse,
  Alert,
} from "reactstrap";
import classnames from "classnames";

import { toast } from "react-toastify";
import imageEmpty from "../../assets/images/new.png";
// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";

//Import actions
import {
  getProducts as onGetProducts,
  deleteProducts,
  setProductFlag,
  getProductById as onGetProductById,
  getHotProducts as onGetHotProducts,
  getMyProducts as onGetMyProducts,
  downloadProducts as onDownloadProducts,
} from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { createSelector } from "reselect";
import Loader from "../../Components/Common/Loader";
import ProductDetail from "./ProductDetail";
import Nouislider from "nouislider-react";
import { productStatusTypes } from "../../Components/constants/layout";
import SalesChannels from "../../Components/Common/SalesChannels";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";
import moment from "moment";
import { getLoggedinUser } from "../../utils/StorageManager";
import { formatCurrency } from "../../utils/Formater";
import { getGlobalSettings } from "../../apiCalls/caller";

// Persisted table preferences
const SESSION_KEYS = {
  rowsPerPage: "products.table.rowsPerPage",
  sort: "products.table.sort",
};
const SAVED_RPP = (() => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEYS.rowsPerPage);
    const val = raw ? JSON.parse(raw) : null;
    return typeof val === "number" ? val : null;
  } catch (e) {
    return null;
  }
})();
const SAVED_SORT = (() => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEYS.sort);
    const val = raw ? JSON.parse(raw) : null;
    if (val && typeof val.id === "string") return val;
    return null;
  } catch (e) {
    return null;
  }
})();

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <input
      {...props}
      value={value}
      id="search-bar-0"
      className="form-control search"
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

const Products = (props) => {
  const dispatch = useDispatch();
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 0,
    totalItems: 0,
    totalPages: 0,
    totalOrdered: 0,
    totalReady: 0,
    totalCancelled: 0,
    totalPendingOrders: 0,
    totalActive: 0,
    totalInactive: 0,
    totalInStock: 0,
    totalOutOfStock: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalStockNotifications: 0,
    total: 0,
  });

  const selectProductData = createSelector(
    (state) => state.Products,
    (products) => products,
    (hotProducts) => hotProducts
  );
  // Inside your component
  const { product, products, hotProducts, myProducts, paginationList, paginationHot, paginationMyProducts } =
    useSelector(selectProductData);

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productList, setProductList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [selectedMulti, setselectedMulti] = useState(null);
  //const [productById, setProductById] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [fbaSelected, setFbaSelected] = useState(false);
  const [fbmSelected, setFbmSelected] = useState(false);
  const [ebaySelected, setEbaySelected] = useState(false);
  const [anySelected, setAnySelected] = useState(false);
  const [onlineSelected, setOnlineSelected] = useState(false);
  const [liquidationsSelected, setLiquidationsSelected] = useState(false);
  const [walmartSelected, setWalmartSelected] = useState(false);
  const [restrictedAmazon, setRestrictedAmazon] = useState(false);
  const [restrictedWalmart, setRestrictedWalmart] = useState(false);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(1000);
  const [minPriceInput, setMinPriceInput] = useState("0");
  const [maxPriceInput, setMaxPriceInput] = useState("1000");
  const [searchText, setSearchText] = useState(null);
  const lastQueryRef = useRef(null);
  const [sortBy, setSortBy] = useState(SAVED_SORT?.id || "pro_lastModifiedDate");
  const [sortDesc, setSortDesc] = useState(!!SAVED_SORT?.desc || true);
  const [globalSettings, setGlobalSettings] = useState(null);

  const auth_user = getLoggedinUser();
  //const debouncedPrice = useDebounce(maxPrice, 50000);

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  useEffect(() => {
    if (products && hotProducts) {
      if (activeTab === "2") {
        setFilteredProducts(hotProducts);
        setPagination(paginationHot);
      } else if (activeTab === "7") {
        setFilteredProducts(myProducts || []);
        setPagination(paginationMyProducts);
      } else {
        setFilteredProducts(products);
        setPagination(paginationList);
      }
      setIsFirstLoad(false);
      // Unlock next fetch attempts after data reception
      lastQueryRef.current = null;
    }
  }, [products, hotProducts, myProducts]);

  useEffect(() => {
    if (product && !isFirstLoad) setDetailsModal(true);
  }, [product]);

  useEffect(() => {
    setIsLoading(false);
  }, [filteredProducts]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (tab === "2") {
        setFilteredProducts(hotProducts);
        setPagination(paginationHot);
        setIsLoading(false);
      } else if (tab === "7") {
        setFilteredProducts(myProducts || []);
        setPagination(paginationMyProducts);
        setIsLoading(false);
      }
    }
  };

  const getProducts = (page, pageSize) => {
    setIsLoading(true);
    const data = {
      page: page ? page : 0,
      total_rows: pageSize ? pageSize : pagination ? pagination?.pageSize : 50,
      priceFrom: minPrice,
      priceTo: maxPrice ? maxPrice : null,
      searchText: searchText,
      restrictedChannels: null,
      salesChannel: null,
      sort_by: sortBy,
      sort_desc: sortDesc,
      favorite: null,
      hidden: null,
      stockAlert: null,
      inStock: null,
    };

    switch (Number(activeTab)) {
      case 3:
        data.favorite = true;
        break;
      case 4:
        data.hidden = true;
        break;
      case 5:
        data.stockAlert = true;
        break;
      case 6:
        data.inStock = true;
        break;
    }
    let salesChannel = null;
    if (fbaSelected) {
      salesChannel += 1;
    }
    if (fbmSelected) {
      salesChannel += 2;
    }
    if (ebaySelected) {
      salesChannel += 4;
    }
    if (walmartSelected) {
      salesChannel += 8;
    }
    if (anySelected) {
      salesChannel += 16;
    }
    if (onlineSelected) {
      salesChannel += 32;
    }
    if (liquidationsSelected) {
      salesChannel += 64;
    }

    data.salesChannel = salesChannel;

    if (restrictedAmazon && restrictedWalmart) {
      data.restrictedChannels = 3;
    } else if (restrictedAmazon) {
      data.restrictedChannels = 1;
    } else if (restrictedWalmart) {
      data.restrictedChannels = 2;
    }

    // Prevent duplicate calls when the same query is already in-flight or just executed
    const queryKey = JSON.stringify({ ...data, tab: activeTab });
    if (lastQueryRef.current === queryKey) {
      setIsLoading(false);
      return;
    }
    lastQueryRef.current = queryKey;

    dispatch(onGetProducts(data));
    dispatch(onGetHotProducts(data));
    dispatch(onGetMyProducts(data));
  };

  const setFlag = (prodId, flag, state) => {
    const data = { pro_id: prodId, flagType: flag, state: state };
    dispatch(setProductFlag(data));
  };

  useEffect(() => {
    !isFirstLoad && getProducts(pagination.currentPage, pagination.pageSize);
  }, [
    fbaSelected,
    fbmSelected,
    ebaySelected,
    walmartSelected,
    anySelected,
    onlineSelected,
    liquidationsSelected,
  ]);

  useEffect(() => {
    !isFirstLoad && getProducts(null, pagination.pageSize);
  }, [restrictedAmazon, restrictedWalmart]);

  useEffect(() => {
    if (products && minPrice && maxPrice) {
      getProducts();
    }
  }, [minPrice, maxPrice]);

  useEffect(() => {
    setMinPriceInput(String(minPrice));
    setMaxPriceInput(String(maxPrice));
  }, [minPrice, maxPrice]);

  useEffect(() => {
    if (!isFirstLoad) {
      getProducts(0, pagination.pageSize);
    }
  }, [searchText]);

  useEffect(() => {
    if (products && activeTab != "2") {
      getProducts(0, pagination.pageSize || SAVED_RPP || 50);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!products) {
      getProducts(0, SAVED_RPP || 50);
    }
    return () => {};
  }, []);

  // Fetch global settings on component mount
  useEffect(() => {
    const fetchGlobalSettings = async () => {
      try {
        const response = await getGlobalSettings();
        if (response && response.data) {
          setGlobalSettings(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch global settings:", error);
      }
    };
    fetchGlobalSettings();
  }, []);

  const onUpdate = (value) => {
    setMinPrice(Number(value[0]));
    setMaxPrice(Number(value[1]));
  };

  const applyMinPrice = () => {
    const value = Number(minPriceInput);
    const nextMinPrice = Number.isFinite(value)
      ? Math.min(Math.max(value, 0), maxPrice)
      : minPrice;

    setMinPrice(nextMinPrice);
    setMinPriceInput(String(nextMinPrice));
  };

  const applyMaxPrice = () => {
    const value = Number(maxPriceInput);
    const nextMaxPrice = Number.isFinite(value)
      ? Math.min(Math.max(value, minPrice), 1000)
      : maxPrice;

    setMaxPrice(nextMaxPrice);
    setMaxPriceInput(String(nextMaxPrice));
  };

  const [ratingvalues, setRatingvalues] = useState([]);
  /*
  on change rating checkbox method
  */
  const onChangeRating = (value) => {
    setFilteredProducts(
      productList.filter((product) => product.rating >= value)
    );

    var modifiedRating = [...ratingvalues];
    modifiedRating.push(value);
    setRatingvalues(modifiedRating);
  };

  const onUncheckMark = (value) => {
    var modifiedRating = [...ratingvalues];
    const modifiedData = (modifiedRating || []).filter((x) => x !== value);
    /*
    find min values
    */
    var filteredProducts = productList;
    if (modifiedData && modifiedData.length && value !== 1) {
      var minValue = Math.min(...modifiedData);
      if (minValue && minValue !== Infinity) {
        filteredProducts = products.filter(
          (product) => product.rating >= minValue
        );
        setRatingvalues(modifiedData);
      }
    } else {
      filteredProducts = products;
    }
    setFilteredProducts(filteredProducts);
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (product) => {
    setSelectedProduct(product);
    setDeleteModal(true);
  };

  const onClickView = (product) => {
    const data = {
      pro_id: product.pro_id,
    };
    window.open(`/products/${product.pro_id}`, "_blank");
    //dispatch(onGetProductById(data));
  };

  const handleDeleteProduct = () => {
    if (selectedProduct) {
      dispatch(deleteProducts(selectedProduct._id));
      setDeleteModal(false);
    }
  };

  // Displat Delete Button
  const [dele, setDele] = useState(0);
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      dispatch(deleteProducts(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
      del.style.display = "none";
    });
  };

  const clearFilters = () => {
    setFbaSelected(false);
    setFbmSelected(false);
    setEbaySelected(false);
    setWalmartSelected(false);
    setAnySelected(false);
    setOnlineSelected(false);
    setLiquidationsSelected(false);
    setSearchText(null);
    setMinPrice(0);
    setMaxPrice(1000);
  };

  const columns = useMemo(
    () => [
      {
        header: "Product",
        accessorKey: "pro_name",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <img
                    src={
                      cell.row.original.pro_imageURLs
                        ? cell.row.original.pro_imageURLs.split(",")[0]
                        : imageEmpty
                    }
                    alt="product-image"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                    }}
                    className="img-fluid d-block"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">{cell.getValue()}</h5>
                <p className="text-muted mb-0">
                  Category :{" "}
                  <span className="fw-medium">
                    {" "}
                    {cell.row.original.pro_categoryName}
                  </span>
                </p>
                {cell.row.original.pro_packQuantity > 1 && (
                  <span className="badge rounded-pill bg-primary text-dark">
                    pack of {cell.row.original.pro_packQuantity}
                  </span>
                )}
                <div className="d-flex align-items-center gap-2">
                  {cell.row.original.pro_MAP != null &&
                    cell.row.original.pro_MAP != "0" && (
                      <div className="tooltip-icon">
                        <i className="ri-price-tag-3-line me-1 text-danger" />
                        <span className="tooltip-text  text-danger">
                          MAP Pricing:{" "}
                          <span className="fw-semibold">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(cell.row.original.pro_MAP)}
                          </span>
                        </span>
                      </div>
                    )}
                  {cell.row.original.pro_extendedLeadTime &&
                    cell.row.original.pro_extendedLeadTime != 0 && (
                      <div className="tooltip-icon">
                        <i className="ri-time-line me-1 text-danger" />
                        <span className="tooltip-text text-danger">
                          Extended Lead Time:{" "}
                          <span className="fw-semibold">
                            {cell.row.original.pro_extendedLeadTime}{" "}
                            {cell.row.original.pro_extendedLeadTime.indexOf(
                              "days"
                            ) < 0
                              ? "days"
                              : ""}
                          </span>
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </>
        ),
      },
      {
        header: "Product Codes",
        accessorKey: "pro_UPCCode",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span>
              {cell.getValue() ? cell.getValue() : "No UPC Code"}
              {cell.row.original.pro_ASIN && (
                <span> / {cell.row.original.pro_ASIN}</span>
              )}
            </span>
          );
        },
      },
      {
        header: "Vetted Channel(s)",
        accessorKey: "pro_salesChannel",
        enableColumnFilter: false,
        cell: (cell) => {
          const salesChannel = cell.getValue();
          return <SalesChannels channel={salesChannel} />;
        },
      },
      {
        header: "Restricted Channel(s)",
        accessorKey: "pro_restrictedChannels",
        enableColumnFilter: false,
        cell: (cell) => {
          const salesChannel = cell.getValue();
          return <RestrictedChannels channel={salesChannel} />;
        },
      },
      {
        header: "last Updated",
        accessorKey: "pro_lastModifiedDate",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {moment(cell.getValue()).format("MM/DD/YYYY")}
            <br />
            <small className="text-muted">
              {"     "}
              {moment(cell.getValue()).format("hh:mm A")}
            </small>
          </>
        ),
      },
      {
        header: "Stock",
        accessorKey: "pro_inStock",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span
              style={{ width: "80px" }}
              className={
                cell.getValue()
                  ? "badge rounded-pill text-dark bg-success"
                  : "badge rounded-pill text-dark bg-danger"
              }
            >
              {cell.getValue() ? "In Stock" : "Out of Stock"}
            </span>
          );
        },
      },

      {
        header: "Price",
        accessorKey: "pro_price",
        enableColumnFilter: false,
        cell: (cell) => {
          const price = cell.getValue();
          return <span>{formatCurrency(price) || 0.0}</span>;
        },
      },
      {
        header: () => (
          <span title="Minimum Cash Output">MCO</span>
        ),
        accessorKey: "pro_MCO",
        enableColumnFilter: false,
        cell: (cell) => {
          const mco = cell.getValue();
          return <span>{formatCurrency(mco)}</span>;
        },
      },

      {
        header: "Action",
        cell: (cell) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn btn-soft-secondary btn-sm"
                tag="button"
              >
                <i className="ri-more-fill" />
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    const productData = cell.row.original;
                    onClickView(productData);
                  }}
                >
                  <i className="ri-eye-fill align-bottom me-2 text-muted"></i>{" "}
                  View
                </DropdownItem>

                <DropdownItem
                  href="#"
                  onClick={() => {
                    const productData = cell.row.original;
                    setFlag(
                      productData.pro_id,
                      productStatusTypes.FAVORITE,
                      !productData.pro_isFavorite
                    );
                  }}
                >
                  <i className="ri-heart-fill align-bottom me-2 text-muted"></i>{" "}
                  {cell.row.original.pro_isFavorite
                    ? "remove from Favorites"
                    : "Mark as favorite"}
                </DropdownItem>
                {cell.row.original.pro_availableStock === 0 && (
                  <DropdownItem
                    href="#"
                    onClick={() => {
                      const productData = cell.row.original;
                      setFlag(
                        productData.pro_id,
                        productStatusTypes.STOCKALERT,
                        true
                      );
                    }}
                  >
                    <i className="ri-notification-fill align-bottom me-2 text-muted"></i>{" "}
                    Notify me when this restocks
                  </DropdownItem>
                )}

                <DropdownItem
                  href="#"
                  onClick={() => {
                    const productData = cell.row.original;
                    setFlag(
                      productData.pro_id,
                      productStatusTypes.HIDDEN,
                      !productData.pro_isHidden
                    );
                  }}
                >
                  <i
                    className={
                      cell.row.original.pro_isHidden
                        ? "ri-eye-fill align-bottom me-2 text-muted"
                        : "ri-eye-off-fill align-bottom me-2 text-muted"
                    }
                  ></i>{" "}
                  {cell.row.original.pro_isHidden ? "Unhide item" : "Hide Item"}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  document.title = "Products | Buyers Club";

  return (
    <div className="page-content">
      <ProductDetail
        product={product}
        show={detailsModal}
        onClose={setDetailsModal}
      />{" "}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Product Catalog" pageTitle="Products" />
        {globalSettings?.gse_userMainWarning && (
          <Alert color="warning" className="text-center">
            <strong>Warning:</strong> {globalSettings.gse_userMainWarning}
          </Alert>
        )}
        {auth_user.user_showWarning && auth_user.user_warningText && (
          <Alert color="warning" className="text-center">
            <strong>Note:</strong> {auth_user.user_warningText}
          </Alert>
        )}

        <Row>
          <Col xl={2} lg={3}>
            <Card>
              <CardHeader>
                <div className="d-flex mb-3">
                  <div className="flex-grow-1">
                    <h5 className="fs-16">Filters</h5>
                  </div>
                  <div className="flex-shrink-0">
                    <Link
                      onClick={clearFilters}
                      className="text-decoration-underline"
                    >
                      Clear All
                    </Link>
                  </div>
                </div>
                <div className="search-box  d-inline-block">
                  <DebouncedInput
                    label="Search"
                    value={searchText ?? ""}
                    onChange={(value) => {
                      setSearchText(value == "" ? null : value);
                    }}
                    placeholder="Search products"
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
              </CardHeader>

              <div className="accordion accordion-flush">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button bg-transparent shadow-none"
                      type="button"
                      id="flush-headingBrands"
                    >
                      <span className="text-muted text-uppercase fs-12 fw-medium">
                        Vetted Channels
                      </span>{" "}
                    </button>
                  </h2>
                  <UncontrolledCollapse
                    toggler="#flush-headingBrands"
                    defaultOpen
                  >
                    <div
                      id="flush-collapseBrands"
                      className="accordion-collapse collapse show"
                      aria-labelledby="flush-headingBrands"
                    >
                      <div className="accordion-body text-body pt-0">
                        <div className="d-flex flex-column gap-2 mt-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio5"
                              value={fbmSelected}
                              onChange={() => setFbmSelected(!fbmSelected)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio5"
                            >
                              FBM
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio4"
                              value={fbaSelected}
                              onChange={() => {
                                setFbaSelected(!fbaSelected);
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio4"
                            >
                              FBA
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio3"
                              value={ebaySelected}
                              onChange={() => setEbaySelected(!ebaySelected)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio3"
                            >
                              eBay
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio6"
                              value={walmartSelected}
                              onChange={() =>
                                setWalmartSelected(!walmartSelected)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio6"
                            >
                              Walmart
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio7"
                              value={anySelected}
                              onChange={() => setAnySelected(!anySelected)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio7"
                            >
                              Other
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio8"
                              value={onlineSelected}
                              onChange={() =>
                                setOnlineSelected(!onlineSelected)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio8"
                            >
                              Online Store
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="productBrandRadio9"
                              value={liquidationsSelected}
                              onChange={() =>
                                setLiquidationsSelected(!liquidationsSelected)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="productBrandRadio9"
                            >
                              Liquidations
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </UncontrolledCollapse>
                </div>

                <div className="card-body border-bottom">
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-4">
                    Price Range
                  </p>

                  <Nouislider
                    range={{
                      min: 0,
                      max: 1000,
                    }}
                    start={[0, 1000]}
                    values={[minPrice, maxPrice]} //must be an array of two numbers
                    connect
                    data-slider-color="primary"
                    id="product-price-range"
                    onEnd={(value) => onUpdate(value)}
                  />
                  <div className="formCost d-flex gap-2 align-items-center mt-3">
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      id="minCost"
                      min={0}
                      max={maxPrice}
                      value={minPriceInput}
                      onChange={(e) => setMinPriceInput(e.target.value)}
                      onBlur={applyMinPrice}
                      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
                    />
                    <span className="fw-semibold text-muted">to</span>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      id="maxCost"
                      min={minPrice}
                      max={1000}
                      value={maxPriceInput}
                      onChange={(e) => setMaxPriceInput(e.target.value)}
                      onBlur={applyMaxPrice}
                      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <div className="col-xl-10 col-lg-9">
            <div>
              <div className="card">
                <div className="card-header border-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "HotList");
                            }}
                            href="#"
                          >
                            Hot List
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationHot.totalItems}
                            </span>
                          </NavLink>
                        </NavItem>
                        {myProducts && myProducts.length > 0 && (
                          <NavItem>
                            <NavLink
                              className={classnames(
                                { active: activeTab === "7" },
                                "fw-semibold"
                              )}
                              onClick={() => {
                                toggleTab("7", "MyProducts");
                              }}
                              href="#"
                            >
                              My Products
                              <span className="badge bg-primary-subtle text-primary align-middle rounded-pill ms-1">
                                {paginationMyProducts.totalItems}
                              </span>
                            </NavLink>
                          </NavItem>
                        )}
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "1" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "All");
                            }}
                            href="#"
                          >
                            All{" "}
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationList.total}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "6" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("6", "InStock");
                            }}
                            href="#"
                          >
                            In Stock
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationList.totalInStock}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "Favorites");
                            }}
                            href="#"
                          >
                            Favorites
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationList?.totalFavorites}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "4" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("4", "Hidden");
                            }}
                            href="#"
                          >
                            Hidden
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationList.totalHidden}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "5" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("5", "RestockNotification");
                            }}
                            href="#"
                          >
                            Restock Notification
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationList.totalStockNotifications}
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <div className="col text-end">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            dispatch(onDownloadProducts());
                          }}
                        >
                          Download Catalog
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={filteredProducts || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={5}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle table-borderless"
                      theadClass="table-light text-dark text-uppercase"
                      isProductsFilter={true}
                      SearchPlaceholder="Search Products..."
                      pagination={pagination}
                      manualPagination={true}
                      onPreviousPage={() => {
                        getProducts(pagination.currentPage - 1);
                      }}
                      onNextPage={() => {
                        getProducts(pagination.currentPage + 1);
                      }}
                      onGetPage={(page, pageSize) => {
                        getProducts(page, pageSize);
                      }}
                      onRowClick={(row) => {
                        onClickView(row);
                      }}
                      onSortChange={(srt) => {
                        if (!srt) return;
                        const nextId = srt.id;
                        const nextDesc = !!srt.desc;
                        if (nextId !== sortBy || nextDesc !== sortDesc) {
                          setSortBy(nextId);
                          setSortDesc(nextDesc);
                          // Trigger fetch with same page size but reset to first page
                          getProducts(
                            0,
                            pagination.pageSize || SAVED_RPP || 50
                          );
                        }
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Products;
